import str from "@/utils/str";

export default {
  data() {
    return {
      searchData: {},
      third_party: ['tg', 'saba','wm_casino'],
    };
  },
  created() {
    if (!this.hasParams) {
      this.$router.push({ name: "tg_business.member.reward" });
    }
    this.third_party = this.params.third_party ? this.params.third_party : this.third_party;
  },
  mounted() {
    this.addBreadcrumb();
  },
  computed: {
    hasParams() {
      return this.$history.exist(this.historyKey);
    },
    params() {
      return this.$history.get(this.historyKey);
    },
  },
  methods: {
    handleSearch(searchHandler) {
      let request = {...this.searchData, third_party: this.third_party};
      searchHandler(request);
    },
    addBreadcrumb() {
      if (!this.params) {
        return;
      }
      this.$store.commit("breadcrumb/add", {
        name: "tg_business.member.reward.games",
        query: {
          ...this.$route.query,
          h: this.historyKey,
          third_party:this.params.third_party
        },
        path: this.$route.path,
        meta: {
          title: str.format(
            "[{0}] {1} ({2})",
            this.params.title,
            this.params.username,
            this.params.usernickname
          ),
        },
      });
    },
  },
  watch: {
    "params.third_party" (value) {
      if (value) {
          this.third_party = value;
      }
    }
}
};
